<template>
    <div class="ibox">
        <div class="ibox-title">
            <h5>Edição do Parceiro</h5>
        </div>

        <div class="ibox-content">
            <form>
                <div>
                    <label for="name" class="control-label">Nome do Parceiro / Razão Social *</label>
                    <div class="form-group" :class="{ 'has-error': form.errors.has('name') }">
                        <input type="text" id="name" class="form-control" maxlength="255" v-model="form.name" required>
                    </div>

                    <label for="contact_name" class="control-label">Nome do Contato</label>
                    <div class="form-group" :class="{ 'has-error': form.errors.has('contact_name') }">
                        <input type="text" id="contact_name" class="form-control" maxlength="255" v-model="form.contact_name">
                    </div>

                    <label for="contact_mobile_phone" class="control-label">Celular do Contato</label>
                    <div class="form-group" :class="{ 'has-error': form.errors.has('contact_mobile_phone') }">
                        <input type="number" id="name" class="form-control" maxlength="15" v-model="form.contact_mobile_phone">
                    </div>

                    <label for="email" class="control-label">Email para comunicação</label>
                    <div class="form-group" :class="{ 'has-error': form.errors.has('email') }">
                        <input type="email" id="email" class="form-control" maxlength="255" v-model="form.email">
                    </div>

                    <label for="send_email" class="control-label">Envia email de comunicação *</label>
                    <div class="form-group">
                        <select name="send_email" class="form-control" v-model="form.send_email" required>
                            <option value="0">Não</option>
                            <option value="1">Sim</option>
                        </select>
                    </div>

                    <label for="coupon_code" class="control-label">Código do Cupom *</label>
                    <div class="form-group" :class="{ 'has-error': form.errors.has('coupon_code') }">
                        <input type="text" id="coupon_code" class="form-control" minlength="5" maxlength="50"  v-model="form.coupon_code" required>
                    </div>

                    <label for="coupon_for" class="control-label">Cupom para quem *</label>
                    <div class="form-group" :class="{ 'has-error': form.errors.has('coupon_for') }">
                        <select name="coupon_for" class="form-control" v-model="form.coupon_for" required>
                            <option value="">Selecione uma opção</option>
                            <option value="expert">Perito</option>
                            <option value="contractor">Contratante</option>
                            <option value="all">Todos</option>
                        </select>
                    </div>

                    <label for="coupon_cashback_percentage" class="control-label">Percentual de Cashback do Cupom (%)</label>
                    <div class="form-group" :class="{ 'has-error': form.errors.has('coupon_cashback_percentage') }">
                        <input type="number" id="coupon_cashback_percentage" class="form-control" min="0" max="100" step="0.01" v-model="form.coupon_cashback_percentage" placeholder="Ex: 5.00">
                        <small class="help-block">Percentual de cashback para este cupom (deixe vazio se não aplicável)</small>
                    </div>

                    <label for="active" class="control-label">Status *</label>
                    <div class="form-group" :class="{ 'has-error': form.errors.has('active') }">
                        <select name="active" class="form-control" v-model="form.active" required>
                            <option value="1">Ativo</option>
                            <option value="0">Inativo</option>
                        </select>
                    </div>

                </div>
                
                <div class="form-group">
                    <button class="btn btn-md btn-primary"
                            type="button"
                            :disabled="disabelBtnUpdate"
                            @click.prevent="onUpdate"
                    >
                    Atualizar
                    </button>

                    <!--
                    <button class="btn btn-md btn-danger"
                            type="button"
                            :disabled="disabelBtnDelete"
                            @click.prevent="onDelete"
                    >
                    Excluir
                    </button>
                    -->

                    <a class="btn btn-md btn-default"  href="/admin/configuracoes/partnership">Voltar</a>
                </div>

            </form>
        </div>
    </div>
</template>

<script>
import Form from 'form-backend-validation';

export default {
  props: {
    partnership: {
        type: Object,
        required: true,
    },
  },
  data() {
      return {
          form: new Form({
              ...this.partnership,
          }),
          disabelBtnUpdate : false,
          disabelBtnDelete : false
      };
  },
  mounted() {
    this.treatForm();
  },
  methods: {
      treatForm() 
      {
        if ( this.form.active == true )
        {
            this.form.active = 1;    
        }
        else 
        {
            this.form.active = 0;
        }

        if ( this.form.send_email == true )
        {
            this.form.send_email = 1;
        }
        else
        {
            this.form.send_email = 0;
        }
      },
      onUpdate() {
          this.disabelBtnUpdate = true;
          this.form.patch('/admin/configuracoes/partnership/'+this.partnership.id)
            .then((data) => {
                this.form = new Form(data);
                this.treatForm();
                this.disabelBtnUpdate = false;
                toastr.success('Parceiro atualizado com sucesso');
            }).catch(() => {
                this.disabelBtnUpdate = false;
                toastr.error('Erro ao atualizar o parceiro');
            });
      },
      onDelete(field) {
        //
        //  this.disabelBtnDelete = true;
        //  axios.delete('/admin/configuracoes/partnership/'+this.partnership.id)
        //    .then(() => {
        //        toastr.success('Parceiro removido com sucesso');
        //        location.href = '/admin/configuracoes/partnership';
        //    }).catch(() => {
        //        this.disabelBtnDelete = false;
        //        toastr.error('Erro ao remover parceiro');
        //    });
      }
  }
}
</script>
